<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <responsavel-form
            v-show="isModalVisible"
            @close="closeModal"
            :afterCreateAction="loadList"
            :action="responsavelAction"
            :responsavel="responsavel"
          ></responsavel-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Responsáveis Cadastrados</h4>
                  </div>
                  <div class="float-right">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="novoResponsavel"
                    >
                      Cadastrar novo responsável
                    </button>
                  </div>
                </template>
                <div class="ml-3 mb-4">
                  <div class="d-flex">
                    <div class="d-flex mr-3">
                      <div class="d-flex pr-2 align-items-center">
                        <label for="perfil">Estado</label>
                      </div>
                      <select v-model="filtros.estado" class="form-control">
                        <option
                          v-for="estado in estados"
                          :value="estado.value"
                          :label="estado.label"
                          :key="estado.label"
                        ></option>
                      </select>
                    </div>
                    <div class="d-flex mr-5">
                      <base-checkbox
                        v-model="filtros.ativo"
                        :inline="true"
                        class="d-flex align-items-center"
                      />
                      <label for="ativo" class="d-flex align-items-center mb-0"
                        >Somente ativos</label
                      >
                    </div>
                    <button @click="loadList()" class="btn btn-success mr-2">
                      Filtrar
                    </button>
                    <button
                      @click="limparFiltrosEBuscarLista()"
                      class="btn btn-danger"
                    >
                      Limpar filtros
                    </button>
                  </div>
                </div>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaResponsaveis.columns"
                  :data="tabelaResponsaveis.data"
                >
                  <template slot-scope="{ row }">
                    <td>
                      <b>{{ row.nome }}</b>
                    </td>
                    <td>{{ row.estado }}</td>
                    <td>
                      <VueToggles
                        @click="changeAtivo(row._id)"
                        :value="row.ativo"
                        checkedBg="#1DC7EA"
                      />
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        @click="editarResponsavel(row)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-icon btn-danger"
                        @click="handleDelete(row)"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    v-if="tabelaResponsaveis.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir o responsável?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deleteResponsavel()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ResponsavelForm from './Forms/ResponsavelForm.vue';
import LTable from 'src/components/Table.vue';
import ResponsavelServices from 'src/services/responsavelEstado';
import vPagination from 'vue-plain-pagination';
import { estadosBr } from '../utils';
import VueToggles from 'vue-toggles';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Nome', 'Estado', 'Ativo'];
export default {
  components: {
    ResponsavelForm,
    LTable,
    vPagination,
    VueToggles
  },
  data() {
    return {
      tabelaResponsaveis: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      responsavelAction: '',
      responsavel: {},
      isDeleteModalVisible: false,
      responsavelToDelete: {},
      currentPage: 1,
      totalPages: Number,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link btn-info'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      filtros: {
        ativo: false,
        estado: ''
      },
      estados: estadosBr
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
      const params = {
        page: this.currentPage,
        estado: this.filtros.estado,
        somenteAtivos: this.filtros.ativo
      };
      ResponsavelServices.listar(params)
        .then(response => {
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          this.tabelaResponsaveis.data = _.get(response, 'data.result');
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    novoResponsavel() {
      this.responsavelAction = 'NEW';
      this.responsavel = {};
      this.isModalVisible = true;
    },
    editarResponsavel(responsavel) {
      this.responsavelAction = 'EDIT';
      this.responsavel = { ...responsavel };
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.responsavelToDelete = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.responsavelToDelete = {};
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deleteResponsavel() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com Sucesso.',
          'fa fa-check'
        );
        this.closeDeleteModal();
        this.loadList();
        loader.hide();
      };

      const errorCallback = err => {
        this.notifyVue(
          'top',
          'center',
          'danger',
          err,
          'fa fa-exclamation-triangle'
        );
        this.closeDeleteModal();
        loader.hide();
      };

      ResponsavelServices.deletar(this.responsavelToDelete)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    changeAtivo(id) {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.loadList();
        loader.hide();
      };

      const errorCallback = err => {
        this.notifyVue(
          'top',
          'center',
          'danger',
          err,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      ResponsavelServices.trocarAtivo(id)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    limparFiltrosEBuscarLista() {
      this.filtros = {
        estado: '',
        ativo: false
      };
      this.loadList();
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
